import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../../lib/api";

const Ctx = createContext(null);

export const GuardProvider = ({ children }) => {
  const [st, setSt] = useState(null);
  const reload = useCallback(() => api.get("/guard/status").then((r) => setSt(r.data)).catch(() => {}), []);
  useEffect(() => { reload(); const t = setInterval(reload, 30000); return () => clearInterval(t); }, [reload]);
  return <Ctx.Provider value={{ st, reload }}>{children}</Ctx.Provider>;
};

export const useGuard = () => useContext(Ctx) || { st: null, reload: () => {} };
